<h5 mat-dialog-title>{{data.title}}</h5>
<p *ngIf="data?.text" mat-dialog-content>{{data.text}}</p>
<div class="flex-justify-center" mat-dialog-actions>
  <button *ngIf="data?.buttonCancel" mat-dialog-close mat-raised-button>{{data?.buttonCancel}}</button>
  <button [mat-dialog-close]="true" cdkFocusInitial class="mat-primary" mat-raised-button>{{data?.buttonText}}</button>
</div>
